import { remCSS } from '@gimlite/common';
import classNames from 'classnames';
import { memo } from 'react';
import TwoSides from '../../assets/icons/2sides';
import Add from '../../assets/icons/add';
import AI from '../../assets/icons/AI';
import Alarm from '../../assets/icons/alarm';
import Arrow_double_vertical from '../../assets/icons/arrow_double_vertical';
import Arrow_left from '../../assets/icons/arrow_left';
import ArrowList from '../../assets/icons/arrow_list';
import ArrowRight from '../../assets/icons/arrow_right';
import BagMoney from '../../assets/icons/bag_money';
import Bend from '../../assets/icons/bend';
import Calendar_month from '../../assets/icons/calendar_month';
import Car from '../../assets/icons/car';
import Card2 from '../../assets/icons/card2';
import CaretDown from '../../assets/icons/caret_down';
import CaretUp from '../../assets/icons/caret_up';
import Cash from '../../assets/icons/cash';
import Check from '../../assets/icons/check';
import CheckFill from '../../assets/icons/check_fill';
import CheckboxActive from '../../assets/icons/checkbox-active';
import CheckboxDeselect from '../../assets/icons/checkbox-deselect';
import CheckboxUnactive from '../../assets/icons/checkbox-unactive';
import Close from '../../assets/icons/close';
import Collapse from '../../assets/icons/collapse';
import Collect from '../../assets/icons/collect';
import Copy from '../../assets/icons/copy';
import Cross from '../../assets/icons/cross';
import Delete from '../../assets/icons/delete';
import Dev from '../../assets/icons/dev';
import Doc from '../../assets/icons/doc';
import Download from '../../assets/icons/download';
import Dropdown from '../../assets/icons/dropdown';
import Edit from '../../assets/icons/edit';
import Ellipsis from '../../assets/icons/ellipsis';
import Expand from '../../assets/icons/expand';
import Export from '../../assets/icons/export';
import Eye from '../../assets/icons/eye';
import Filter from '../../assets/icons/filter';
import Gear from '../../assets/icons/gear';
import Globe from '../../assets/icons/globe';
import Gps from '../../assets/icons/gps';
import Grid from '../../assets/icons/grid';
import Hand from '../../assets/icons/hand';
import Horodator from '../../assets/icons/horodator';
import Image from '../../assets/icons/image';
import { Info2 } from '../../assets/icons/info2';
import Layer from '../../assets/icons/layer';
import Link from '../../assets/icons/link';
import List from '../../assets/icons/list';
import Loader from '../../assets/icons/loader';
import Logout from '../../assets/icons/logout';
import Mail from '../../assets/icons/mail';
import Map from '../../assets/icons/map';
import Minus from '../../assets/icons/minus';
import Module from '../../assets/icons/module';
import More from '../../assets/icons/more';
import Move from '../../assets/icons/move';
import NoData from '../../assets/icons/noData';
import Pen from '../../assets/icons/pen';
import Profil from '../../assets/icons/profil';
import Refresh from '../../assets/icons/refresh';
import Revert from '../../assets/icons/revert';
import Search from '../../assets/icons/search';
import Setting from '../../assets/icons/setting';
import Sort from '../../assets/icons/sort';
import Substract from '../../assets/icons/substract';
import Ticket from '../../assets/icons/ticket';
import Traffic from '../../assets/icons/traffic';
import Transmission from '../../assets/icons/transmission';
import TypeMap from '../../assets/icons/typeMap';
import Undo from '../../assets/icons/undo';
import Unexpand from '../../assets/icons/unexpand';
import Union from '../../assets/icons/union';
import Unlink from '../../assets/icons/unlink';
import Upload from '../../assets/icons/upload';
import User from '../../assets/icons/user';
import { ColorType } from '../../types/component.type';
import './icon.component.scss';
import DeleteFields from '../../assets/icons/deleteFields';
import FRA from '../../assets/icons/flag_FRA';
import GBR from '../../assets/icons/flag_GBR';
import DEU from '../../assets/icons/flag_DEU';
import ITA from '../../assets/icons/flag_ITA';
import Camera from '../../assets/icons/camera';
import EyeHide from '../../assets/icons/eye_hide';
import Column from '../../assets/icons/column';
import Graph from '../../assets/icons/graph';
import Inactive from '../../assets/icons/inactive';
import AddRound from '../../assets/icons/addRound';
import Order from '../../assets/icons/order';
import BlockMinus from '../../assets/icons/blockMinus';
import BlockPlus from '../../assets/icons/blockPlus';
import ChevronUp from '../../assets/icons/chevron_up';
import Rotate from '../../assets/icons/rotate';
import Baterry from '../../assets/icons/baterry';
import ChevronDown from '../../assets/icons/chevron_down';
import Deactive from '../../assets/icons/deactive';

const iconsMapper = {
  arrow_right: <ArrowRight />,
  cash: <Cash />,
  collect: <Collect />,
  doc: <Doc />,
  horodator: <Horodator />,
  mail: <Mail />,
  map: <Map />,
  module: <Module />,
  dropdown: <Dropdown />,
  card2: <Card2 />,
  '2sides': <TwoSides />,
  search: <Search />,
  filter: <Filter />,
  sort: <Sort />,
  caret_up: <CaretUp />,
  caret_down: <CaretDown />,
  check: <Check />,
  'checkbox-active': <CheckboxActive />,
  'checkbox-deselect': <CheckboxDeselect />,
  'checkbox-unactive': <CheckboxUnactive />,
  info2: <Info2 />,
  more: <More />,
  eye: <Eye />,
  close: <Close />,
  edit: <Edit />,
  ellipsis: <Ellipsis />,
  calendarMonth: <Calendar_month />,
  arrow_left: <Arrow_left />,
  loader: <Loader />,
  arrow_double_vertical: <Arrow_double_vertical />,
  transmission: <Transmission />,
  grid: <Grid />,
  list: <List />,
  export: <Export />,
  ticket: <Ticket />,
  bag_money: <BagMoney />,
  user: <User />,
  car: <Car />,
  collapse: <Collapse />,
  alarm: <Alarm />,
  download: <Download />,
  dev: <Dev />,
  upload: <Upload />,
  noData: <NoData />,
  gear: <Gear />,
  expand: <Expand />,
  unexpand: <Unexpand />,
  refresh: <Refresh />,
  delete: <Delete />,
  unlink: <Unlink />,
  link: <Link />,
  union: <Union />,
  cross: <Cross />,
  hand: <Hand />,
  pen: <Pen />,
  bend: <Bend />,
  undo: <Undo />,
  revert: <Revert />,
  add: <Add />,
  minus: <Minus />,
  typeMap: <TypeMap />,
  gps: <Gps />,
  copy: <Copy />,
  check_fill: <CheckFill />,
  profil: <Profil />,
  logout: <Logout />,
  setting: <Setting />,
  arrow_list: <ArrowList />,
  image: <Image />,
  globe: <Globe />,
  move: <Move />,
  traffic: <Traffic />,
  layer: <Layer />,
  substract: <Substract />,
  ai: <AI />,
  deleteFields: <DeleteFields />,
  FRA: <FRA />,
  GBR: <GBR />,
  DEU: <DEU />,
  ITA: <ITA />,
  camera: <Camera />,
  eye_hide: <EyeHide />,
  column: <Column />,
  graph: <Graph />,
  inactive: <Inactive />,
  addRound: <AddRound />,
  order: <Order />,
  chevron_up: <ChevronUp />,
  chevron_down: <ChevronDown />,
  blockMinus: <BlockMinus />,
  blockPlus: <BlockPlus />,
  rotate: <Rotate />,
  baterry: <Baterry />,
  deactive: <Deactive />,
} as const satisfies Record<string, React.ReactNode>;

const sizeMapper = {
  initial: null,
  xxs: remCSS(9),
  xs: remCSS(16),
  s: remCSS(20),
  m: remCSS(24),
  l: remCSS(32),
  xl: remCSS(48),
  xxl: remCSS(64),
} as const satisfies Record<string, string | null>;

export declare namespace IconType {
  type Props = {
    className?: string | null;
    variant: keyof typeof iconsMapper;
    color?: ColorType | null;
    size?: keyof typeof sizeMapper;
  };
}

export const Icon = memo(
  ({ variant, className, color, size = 'm' }: IconType.Props) => {
    return (
      <div
        className={classNames(
          `icon`,
          `icon--color--${color}`,
          {
            'icon--size--initial': size === 'initial',
            'icon--size--custom': size !== 'initial',
          },
          className,
        )}
        style={{
          width: sizeMapper[size] ? `${sizeMapper[size]}` : undefined,
          height: sizeMapper[size] ? `${sizeMapper[size]}` : undefined,
          minWidth: sizeMapper[size] ? `${sizeMapper[size]}` : undefined,
          minHeight: sizeMapper[size] ? `${sizeMapper[size]}` : undefined,
        }}
      >
        {iconsMapper?.[variant] || null}
      </div>
    );
  },
);
